import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableC from '../../basicElement/TableC';
import { Modal, Button, message, Popconfirm } from 'antd';
import Fetch from '../../../common/Fetch';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import Filter from './components/Filter';
import Update from './components/Update';
import ExportUtil from '../../../common/ExportUtil';
import { saveParams } from '../../../actions/noticeActions';
import cf from '../../../utils/cf';
import fp from '../../../utils/fp';
import SideNav from '../UserSider';
import './style.less';

const MedicineTypeList = [
    { label: '药物', value: 'Research_drugs' },
    { label: '技术类（如细胞技术）', value: 'Technology' },
    { label: '医疗器械', value: 'Medical_instruments' },
    { label: '疫苗', value: 'Vaccines' },
    { label: '诊断试剂', value: 'Diagnostic_reagent' },
    { label: '其他', value: 'Others' },
];

class FieldLeader extends Component {
    constructor(props) {
        super(props);
        const { params } = props;
        const searchParams = {};
        if (params.applyCode) {
            searchParams.applyCode = params.applyCode;
        }
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            curParams: {...searchParams},
            searchParams,
            pagination: {
                pageSize: 10,
                current: 1,
            },
            fieldList: [],
            departmentList: [],
            listCollection: [],
            areaList: [],
            typeList: [],
            businessList: [],
            byStageList: [],
            LineUserList: [],
        };
    }
    
    componentDidMount() {
        this.loadData();
        this.selectDepartment();
        this.queryResponsibleField();
        this.queryResponsibleFieldList();
        this.queryWithLevelByParams('LINE_OF_BUSINESS');
        this.loadTypeConfigureList();
        this.queryAllLineUser();
    }

    componentWillUnmount() {
        const { saveParams } = this.props;
        saveParams({ applyCode: '' });
    }

    getChildContext = () => {
        const { fieldList, listCollection } = this.state;
        return {
            fieldList,
            listCollection
        };
    }

    selectDepartment = () => {
        Fetch.post(API_URL.user.selectDepartment)
        .then(res => {
            this.setState({
                departmentList: res.datas,
            });
        }).catch(err => {
            console.error(err);
        });
    }

    
    queryAllLineUser = () => {
        Fetch.post(API_URL.user.queryAllLineUser, {}).then(res => {
            this.setState({ LineUserList: res.userList })
        })
    }

    queryResponsibleField = () => {
        Fetch.post(API_URL.user.queryResponsibleField)
        .then(res => {
            this.setState({
                listCollection: res.datas,
            });
        }).catch(err => {
            console.error(err);
        });
    }

    queryResponsibleFieldList = () => {
        Fetch.post(API_URL.user.queryResponsibleFieldList)
        .then(res => {
            this.setState({
                fieldList: res.datas,
            });
        }).catch(err => {
            console.error(err);
        });
    }

    queryWithLevelByParams = (typeName) => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { typeConfigureList } = res;
            this.setState({ businessList: typeConfigureList || [] });
        });
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({
                areaList: res.areaList,
                typeList: res.typeList,
            });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(curParams);
        Fetch.post(API_URL.user.selectLeader, {
            offset: current,
            limit: pageSize,
            ...sortParams,
            ...params,
            curInvId: '',
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                loading: false,
                data: datas,
                pagination,
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState(
            {
                pagination,
                curParams: { ...searchParams },
            },
            () => {
                this.loadData();
            }
        );
    };

    export = () => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.user.exportLeader;
        ExportUtil.export({ ...sortParams, ...searchParams }, null, url);
    }

    delete = (record) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定要删除吗？",
            onOk: () => {
                const { leaderId } = record;
                this.setState({ loading: true });
                Fetch.post(API_URL.user.deleteLeader, {
                    leaderId,
                }).then(res => {
                    message.success("删除成功");
                    this.setState({ loading: false }, () => {
                        this.loadData();
                    });
                }).catch(error => {
                    console.error(error);
                    this.setState({ loading: false });
                });
            },
        });
    }

    getColumns = () => {
        const { curRole, userId } = sessionStorage;
        const columns = [{
            title: '领域leader工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            fixed: 'left',
            width: 100,
        }, {
            title: '领域leader姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            fixed: 'left',
            width: 100,
        }, {
            title: '状态',
            dataIndex: 'workStatus',
            key: 'workStatus',
            width: 80,
            render: text => text === 'WORKING' ? '在职' : '离职 '
        }, {
            title: '部门',
            dataIndex: 'enterpriseDepartmentName',
            key: 'enterpriseDepartmentName',
            width: 120,
        }, {
            title: '部门负责人',
            dataIndex: 'principalName',
            key: 'principalName',
            width: 100,
        }, {
            title: '是否是主领域leader',
            dataIndex: 'isMain',
            key: 'isMain',
            width: 80,
            render: text => text == '1' ? '是' : '否'
        }, {
            title: '负责领域',
            dataIndex: 'leaderFieldName',
            key: 'leaderFieldName',
            width: 300,
            render: (text) => {
                const result = [];
                let start = 0, key = 0;
                (text || '').replace(/并且|或者/g, (...args) => {
                    const [ match, index ] = args;
                    result.push(<span key={key++}>{text.slice(start, index)}</span>);
                    result.push(<span key={key++} style={{ color: '#1C00CF' }}>{match}</span>);
                    start = index + 2;
                });
                if (start > 0) result.push(<span key={key++}>{text.slice(start)}</span>);
                return result.length ? result : text;
            }
        }];
        if (curRole !== 'HRRC' && curRole !== 'BDO' && curRole !== 'BAL') {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                fixed: 'right',
                width: 120,
                render: (text, record) => {
                    const { isMain, leaderId } = record;
                    const { LineUserList } = this.state;
                    const isLineUser =  LineUserList.some( el => el.userId == userId )
                    const operationCorrespondRoles = new Map([
                        ['edit', {
                            name: '修改',
                            display: true,
                            editable: true,
                            event: () => this.update(record, 'edit'),
                            roles: ['BO', 'CSAL'],
                        }],
                        ['delete', {
                            name: '删除',
                            display: true,
                            editable: true,
                            event: () => this.delete(record),
                            roles: ['BO', 'CSAL'],
                        }],
                        ['setMain', {
                            name: <Popconfirm 
                                title={`确认${isMain == '1' ? '取消' : '配置'}该人员为主领域leader吗？ `}
                                onConfirm={() => this.setMainLeader( leaderId, isMain == '1' ? '0' : '1' )} 
                            >
                            <a href="#">{isMain == '1' ? '取消主领域leader' : '设置主领域leader'}</a>
                            </Popconfirm>,
                            display: isLineUser,
                            editable: true,
                            roles: ['*'],
                        }],
                    ]);
                    return (
                        <span>
                            {   fp.compose(
                                    fp.curry(cf.operationAuthByRole)(index => <span key={index} className="ant-divider" />),
                                    fp.filter(i => !!i),
                                    // 获取角色对应操作
                                    fp.curry(cf.authDomList)(operationCorrespondRoles)
                                )(curRole)
                            }
                        </span>
                    );
                }
            }) 
        }
        return columns;
    }

    setMainLeader = ( leaderId, isMain ) => {
        const options = {
            method: 'POST',
            url: API_URL.user.updateLeaderMain,
            data: { leaderId, isMain },
            dataType: 'json',
            doneResult: res => {
                message.success(`${isMain == '1' ? '设置成功' : '取消成功' }`)
                this.loadData()
            },
        };
        $.sendRequest(options);
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    update = (record, type) => {
        this.updateRef.show({...record}, type);
    }

    handleFilterChange = (searchParams, key) => {
        this.setState({ searchParams });
    }

    render() {
        const { 
            data, 
            loading, 
            pagination, 
            searchParams, 
            sortParams, 
            departmentList, 
            listCollection,
            areaList,
            typeList,
            businessList,
            byStageList,
        } = this.state;
        const settings = {
            areaList,
            typeList,
            businessList,
            MedicineTypeList,
            departmentList,
            byStageList
        };
        const { curRole } = sessionStorage;
        return (
            <div className="content">
                <SideNav selectKey='fieldLeader' openKeys={['sub1']}/>
                <div className="main">
                    <Filter
                        {...settings}
                        listCollection={listCollection}
                        search={this.search}
                        params={searchParams}
                        onChange={this.handleFilterChange}
                        buttons={[
                            <Button key="export" type="primary" onClick={this.export}>导出</Button>,
                            (curRole !== 'HRRC' && curRole !== 'BDO' && curRole !== 'BAL') && <Button key="add" type="primary" onClick={() => this.update({}, 'add')}>添加</Button>
                        ]}
                    />
                    <TableC
                        data={data}
                        scrollY={500}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        pagination={pagination}
                        className="fieldLeader"
                        onChange={this.handleTableChange}
                    />
                    <Update ref={el => this.updateRef = el} loadData={this.loadData} />
                </div>
            </div>
        );
    }
}

FieldLeader.childContextTypes = {
    fieldList: PropTypes.array,
    listCollection: PropTypes.array,
};

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FieldLeader);



// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/index.js